import React, { FC, ReactNode } from 'react';

import { cn } from '@/shared/lib/tailwind-merge';

type LayoutProps = {
    children: ReactNode;
    className?: string;
    isBorder?: boolean;
};

const Layout: FC<LayoutProps> = ({ isBorder, className, children }) => {
    return (
        <div
            className={cn(
                'px-[10%] bg-background-primary',
                isBorder && 'border-b border-opaque',
                className,
            )}
        >
            {children}
        </div>
    );
};

export { Layout };
